import DropdownOption from "@/entities/DropdownOption";

const countries: DropdownOption[] = [
  { id: "AD", name: "Andorra" },
  { id: "AF", name: "Afghanistan" },
  { id: "AG", name: "Antigua and Barbuda" },
  { id: "AI", name: "Anguilla" },
  { id: "AL", name: "Albania" },
  { id: "AM", name: "Armenia" },
  { id: "AO", name: "Angola" },
  { id: "AR", name: "Argentina" },
  { id: "AS", name: "American Samoa" },
  { id: "AT", name: "Austria" },
  { id: "AU", name: "Australia" },
  { id: "AW", name: "Aruba" },
  { id: "AX", name: "Åland Islands" },
  { id: "AZ", name: "Azerbaijan" },
  { id: "BA", name: "Bosnia and Herzegovina" },
  { id: "BB", name: "Barbados" },
  { id: "BD", name: "Bangladesh" },
  { id: "BE", name: "Belgium" },
  { id: "BF", name: "Burkina Faso" },
  { id: "BG", name: "Bulgaria" },
  { id: "BH", name: "Bahrain" },
  { id: "BI", name: "Burundi" },
  { id: "BJ", name: "Benin" },
  { id: "BL", name: "Saint Barthélemy" },
  { id: "BM", name: "Bermuda" },
  { id: "BN", name: "Brunei Darussalam" },
  { id: "BO", name: "Bolivia, Plurinational State of" },
  { id: "BQ", name: "Bonaire, Sint Eustatius and Saba" },
  { id: "BR", name: "Brazil" },
  { id: "BS", name: "Bahamas" },
  { id: "BT", name: "Bhutan" },
  { id: "BV", name: "Bouvet Island" },
  { id: "BW", name: "Botswana" },
  { id: "BY", name: "Belarus" },
  { id: "BZ", name: "Belize" },
  { id: "CA", name: "Canada" },
  { id: "CC", name: "Cocos (Keeling) Islands" },
  { id: "CD", name: "Congo, Democratic Republic of the" },
  { id: "CF", name: "Central African Republic" },
  { id: "CG", name: "Congo" },
  { id: "CH", name: "Switzerland" },
  { id: "CI", name: "Côte d'Ivoire" },
  { id: "CK", name: "Cook Islands" },
  { id: "CL", name: "Chile" },
  { id: "CM", name: "Cameroon" },
  { id: "CN", name: "China" },
  { id: "CO", name: "Colombia" },
  { id: "CR", name: "Costa Rica" },
  { id: "CU", name: "Cuba" },
  { id: "CV", name: "Cabo Verde" },
  { id: "CW", name: "Curaçao" },
  { id: "CX", name: "Christmas Island" },
  { id: "CY", name: "Cyprus" },
  { id: "CZ", name: "Czechia" },
  { id: "DE", name: "Germany" },
  { id: "DJ", name: "Djibouti" },
  { id: "DK", name: "Denmark" },
  { id: "DM", name: "Dominica" },
  { id: "DO", name: "Dominican Republic" },
  { id: "DZ", name: "Algeria" },
  { id: "EC", name: "Ecuador" },
  { id: "EE", name: "Estonia" },
  { id: "EG", name: "Egypt" },
  { id: "EH", name: "Western Sahara" },
  { id: "ER", name: "Eritrea" },
  { id: "ES", name: "Spain" },
  { id: "ET", name: "Ethiopia" },
  { id: "FI", name: "Finland" },
  { id: "FJ", name: "Fiji" },
  { id: "FK", name: "Falkland Islands (Malvinas)" },
  { id: "FM", name: "Micronesia, Federated States of" },
  { id: "FO", name: "Faroe Islands" },
  { id: "FR", name: "France" },
  { id: "GA", name: "Gabon" },
  { id: "GB", name: "United Kingdom of Great Britain and Northern Ireland" },
  { id: "GD", name: "Grenada" },
  { id: "GE", name: "Georgia" },
  { id: "GF", name: "French Guiana" },
  { id: "GG", name: "Guernsey" },
  { id: "GH", name: "Ghana" },
  { id: "GI", name: "Gibraltar" },
  { id: "GL", name: "Greenland" },
  { id: "GM", name: "Gambia" },
  { id: "GN", name: "Guinea" },
  { id: "GP", name: "Guadeloupe" },
  { id: "GQ", name: "Equatorial Guinea" },
  { id: "GR", name: "Greece" },
  { id: "GS", name: "South Georgia and the South Sandwich Islands" },
  { id: "GT", name: "Guatemala" },
  { id: "GU", name: "Guam" },
  { id: "GW", name: "Guinea-Bissau" },
  { id: "GY", name: "Guyana" },
  { id: "HK", name: "Hong Kong" },
  { id: "HM", name: "Heard Island and McDonald Islands" },
  { id: "HN", name: "Honduras" },
  { id: "HR", name: "Croatia" },
  { id: "HT", name: "Haiti" },
  { id: "HU", name: "Hungary" },
  { id: "ID", name: "Indonesia" },
  { id: "IE", name: "Ireland" },
  { id: "IL", name: "Israel" },
  { id: "IM", name: "Isle of Man" },
  { id: "IN", name: "India" },
  { id: "IO", name: "British Indian Ocean Territory" },
  { id: "IQ", name: "Iraq" },
  { id: "IR", name: "Iran, Islamic Republic of" },
  { id: "IS", name: "Iceland" },
  { id: "IT", name: "Italy" },
  { id: "JE", name: "Jersey" },
  { id: "JM", name: "Jamaica" },
  { id: "JO", name: "Jordan" },
  { id: "JP", name: "Japan" },
  { id: "KE", name: "Kenya" },
  { id: "KG", name: "Kyrgyzstan" },
  { id: "KH", name: "Cambodia" },
  { id: "KI", name: "Kiribati" },
  { id: "KM", name: "Comoros" },
  { id: "KN", name: "Saint Kitts and Nevis" },
  { id: "KP", name: "Korea, Democratic People's Republic of" },
  { id: "KR", name: "Korea, Republic of" },
  { id: "KW", name: "Kuwait" },
  { id: "KY", name: "Cayman Islands" },
  { id: "KZ", name: "Kazakhstan" },
  { id: "LA", name: "Lao People's Democratic Republic" },
  { id: "LB", name: "Lebanon" },
  { id: "LC", name: "Saint Lucia" },
  { id: "LI", name: "Liechtenstein" },
  { id: "LK", name: "Sri Lanka" },
  { id: "LR", name: "Liberia" },
  { id: "LS", name: "Lesotho" },
  { id: "LT", name: "Lithuania" },
  { id: "LU", name: "Luxembourg" },
  { id: "LV", name: "Latvia" },
  { id: "LY", name: "Libya" },
  { id: "MA", name: "Morocco" },
  { id: "MC", name: "Monaco" },
  { id: "MD", name: "Moldova, Republic of" },
  { id: "ME", name: "Montenegro" },
  { id: "MF", name: "Saint Martin, (French part)" },
  { id: "MG", name: "Madagascar" },
  { id: "MH", name: "Marshall Islands" },
  { id: "MK", name: "North Macedonia" },
  { id: "ML", name: "Mali" },
  { id: "MM", name: "Myanmar" },
  { id: "MN", name: "Mongolia" },
  { id: "MO", name: "Macao" },
  { id: "MP", name: "Northern Mariana Islands" },
  { id: "MQ", name: "Martinique" },
  { id: "MR", name: "Mauritania" },
  { id: "MS", name: "Montserrat" },
  { id: "MT", name: "Malta" },
  { id: "MU", name: "Mauritius" },
  { id: "MV", name: "Maldives" },
  { id: "MW", name: "Malawi" },
  { id: "MX", name: "Mexico" },
  { id: "MY", name: "Malaysia" },
  { id: "MZ", name: "Mozambique" },
  { id: "NA", name: "Namibia" },
  { id: "NC", name: "New Caledonia" },
  { id: "NE", name: "Niger" },
  { id: "NF", name: "Norfolk Island" },
  { id: "NG", name: "Nigeria" },
  { id: "NI", name: "Nicaragua" },
  { id: "NL", name: "Netherlands" },
  { id: "NO", name: "Norway" },
  { id: "NP", name: "Nepal" },
  { id: "NR", name: "Nauru" },
  { id: "NU", name: "Niue" },
  { id: "NZ", name: "New Zealand" },
  { id: "OM", name: "Oman" },
  { id: "PA", name: "Panama" },
  { id: "PE", name: "Peru" },
  { id: "PF", name: "French Polynesia" },
  { id: "PG", name: "Papua New Guinea" },
  { id: "PH", name: "Philippines" },
  { id: "PK", name: "Pakistan" },
  { id: "PL", name: "Poland" },
  { id: "PM", name: "Saint Pierre and Miquelon" },
  { id: "PN", name: "Pitcairn" },
  { id: "PR", name: "Puerto Rico" },
  { id: "PS", name: "Palestine, State of" },
  { id: "PT", name: "Portugal" },
  { id: "PW", name: "Palau" },
  { id: "PY", name: "Paraguay" },
  { id: "QA", name: "Qatar" },
  { id: "RE", name: "Réunion" },
  { id: "RO", name: "Romania" },
  { id: "RS", name: "Serbia" },
  { id: "RU", name: "Russian Federation" },
  { id: "RW", name: "Rwanda" },
  { id: "SA", name: "Saudi Arabia" },
  { id: "SB", name: "Solomon Islands" },
  { id: "SC", name: "Seychelles" },
  { id: "SD", name: "Sudan" },
  { id: "SE", name: "Sweden" },
  { id: "SG", name: "Singapore" },
  { id: "SH", name: "Saint Helena, Ascension and Tristan da Cunha" },
  { id: "SI", name: "Slovenia" },
  { id: "SJ", name: "Svalbard and Jan Mayen" },
  { id: "SK", name: "Slovakia" },
  { id: "SL", name: "Sierra Leone" },
  { id: "SM", name: "San Marino" },
  { id: "SN", name: "Senegal" },
  { id: "SO", name: "Somalia" },
  { id: "SR", name: "Suriname" },
  { id: "SS", name: "South Sudan" },
  { id: "ST", name: "Sao Tome and Principe" },
  { id: "SV", name: "El Salvador" },
  { id: "SX", name: "Sint Maarten, (Dutch part)" },
  { id: "SY", name: "Syrian Arab Republic" },
  { id: "SZ", name: "Eswatini" },
  { id: "TC", name: "Turks and Caicos Islands" },
  { id: "TD", name: "Chad" },
  { id: "TF", name: "French Southern Territories" },
  { id: "TG", name: "Togo" },
  { id: "TH", name: "Thailand" },
  { id: "TJ", name: "Tajikistan" },
  { id: "TK", name: "Tokelau" },
  { id: "TL", name: "Timor-Leste" },
  { id: "TM", name: "Turkmenistan" },
  { id: "TN", name: "Tunisia" },
  { id: "TO", name: "Tonga" },
  { id: "TR", name: "Turkey" },
  { id: "TT", name: "Trinidad and Tobago" },
  { id: "TV", name: "Tuvalu" },
  { id: "TW", name: "Taiwan, Province of China" },
  { id: "TZ", name: "Tanzania, United Republic of" },
  { id: "UA", name: "Ukraine" },
  { id: "UG", name: "Uganda" },
  { id: "AE", name: "United Arab Emirates" },
  { id: "UM", name: "United States Minor Outlying Islands" },
  { id: "US", name: "USA" },
  { id: "UY", name: "Uruguay" },
  { id: "UZ", name: "Uzbekistan" },
  { id: "VA", name: "Holy See" },
  { id: "VC", name: "Saint Vincent and the Grenadines" },
  { id: "VE", name: "Venezuela, Bolivarian Republic of" },
  { id: "VG", name: "Virgin Islands, British" },
  { id: "VI", name: "Virgin Islands, U.S." },
  { id: "VN", name: "Viet Nam" },
  { id: "VU", name: "Vanuatu" },
  { id: "WF", name: "Wallis and Futuna" },
  { id: "WS", name: "Samoa" },
  { id: "YE", name: "Yemen" },
  { id: "YT", name: "Mayotte" },
  { id: "ZA", name: "South Africa" },
  { id: "ZM", name: "Zambia" },
  { id: "ZW", name: "Zimbabwe" },
];
export const countriesByNames = {
  Andorra: {
    id: "AD",
    name: "Andorra",
  },
  Afghanistan: {
    id: "AF",
    name: "Afghanistan",
  },
  "Antigua and Barbuda": {
    id: "AG",
    name: "Antigua and Barbuda",
  },
  Anguilla: {
    id: "AI",
    name: "Anguilla",
  },
  Albania: {
    id: "AL",
    name: "Albania",
  },
  Armenia: {
    id: "AM",
    name: "Armenia",
  },
  Angola: {
    id: "AO",
    name: "Angola",
  },
  Argentina: {
    id: "AR",
    name: "Argentina",
  },
  "American Samoa": {
    id: "AS",
    name: "American Samoa",
  },
  Austria: {
    id: "AT",
    name: "Austria",
  },
  Australia: {
    id: "AU",
    name: "Australia",
  },
  Aruba: {
    id: "AW",
    name: "Aruba",
  },
  "Åland Islands": {
    id: "AX",
    name: "Åland Islands",
  },
  Azerbaijan: {
    id: "AZ",
    name: "Azerbaijan",
  },
  "Bosnia and Herzegovina": {
    id: "BA",
    name: "Bosnia and Herzegovina",
  },
  Barbados: {
    id: "BB",
    name: "Barbados",
  },
  Bangladesh: {
    id: "BD",
    name: "Bangladesh",
  },
  Belgium: {
    id: "BE",
    name: "Belgium",
  },
  "Burkina Faso": {
    id: "BF",
    name: "Burkina Faso",
  },
  Bulgaria: {
    id: "BG",
    name: "Bulgaria",
  },
  Bahrain: {
    id: "BH",
    name: "Bahrain",
  },
  Burundi: {
    id: "BI",
    name: "Burundi",
  },
  Benin: {
    id: "BJ",
    name: "Benin",
  },
  "Saint Barthélemy": {
    id: "BL",
    name: "Saint Barthélemy",
  },
  Bermuda: {
    id: "BM",
    name: "Bermuda",
  },
  "Brunei Darussalam": {
    id: "BN",
    name: "Brunei Darussalam",
  },
  "Bolivia, Plurinational State of": {
    id: "BO",
    name: "Bolivia, Plurinational State of",
  },
  "Bonaire, Sint Eustatius and Saba": {
    id: "BQ",
    name: "Bonaire, Sint Eustatius and Saba",
  },
  Brazil: {
    id: "BR",
    name: "Brazil",
  },
  Bahamas: {
    id: "BS",
    name: "Bahamas",
  },
  Bhutan: {
    id: "BT",
    name: "Bhutan",
  },
  "Bouvet Island": {
    id: "BV",
    name: "Bouvet Island",
  },
  Botswana: {
    id: "BW",
    name: "Botswana",
  },
  Belarus: {
    id: "BY",
    name: "Belarus",
  },
  Belize: {
    id: "BZ",
    name: "Belize",
  },
  Canada: {
    id: "CA",
    name: "Canada",
  },
  "Cocos (Keeling) Islands": {
    id: "CC",
    name: "Cocos (Keeling) Islands",
  },
  "Congo, Democratic Republic of the": {
    id: "CD",
    name: "Congo, Democratic Republic of the",
  },
  "Central African Republic": {
    id: "CF",
    name: "Central African Republic",
  },
  Congo: {
    id: "CG",
    name: "Congo",
  },
  Switzerland: {
    id: "CH",
    name: "Switzerland",
  },
  "Côte d'Ivoire": {
    id: "CI",
    name: "Côte d'Ivoire",
  },
  "Cook Islands": {
    id: "CK",
    name: "Cook Islands",
  },
  Chile: {
    id: "CL",
    name: "Chile",
  },
  Cameroon: {
    id: "CM",
    name: "Cameroon",
  },
  China: {
    id: "CN",
    name: "China",
  },
  Colombia: {
    id: "CO",
    name: "Colombia",
  },
  "Costa Rica": {
    id: "CR",
    name: "Costa Rica",
  },
  Cuba: {
    id: "CU",
    name: "Cuba",
  },
  "Cabo Verde": {
    id: "CV",
    name: "Cabo Verde",
  },
  Curaçao: {
    id: "CW",
    name: "Curaçao",
  },
  "Christmas Island": {
    id: "CX",
    name: "Christmas Island",
  },
  Cyprus: {
    id: "CY",
    name: "Cyprus",
  },
  Czechia: {
    id: "CZ",
    name: "Czechia",
  },
  Germany: {
    id: "DE",
    name: "Germany",
  },
  Djibouti: {
    id: "DJ",
    name: "Djibouti",
  },
  Denmark: {
    id: "DK",
    name: "Denmark",
  },
  Dominica: {
    id: "DM",
    name: "Dominica",
  },
  "Dominican Republic": {
    id: "DO",
    name: "Dominican Republic",
  },
  Algeria: {
    id: "DZ",
    name: "Algeria",
  },
  Ecuador: {
    id: "EC",
    name: "Ecuador",
  },
  Estonia: {
    id: "EE",
    name: "Estonia",
  },
  Egypt: {
    id: "EG",
    name: "Egypt",
  },
  "Western Sahara": {
    id: "EH",
    name: "Western Sahara",
  },
  Eritrea: {
    id: "ER",
    name: "Eritrea",
  },
  Spain: {
    id: "ES",
    name: "Spain",
  },
  Ethiopia: {
    id: "ET",
    name: "Ethiopia",
  },
  Finland: {
    id: "FI",
    name: "Finland",
  },
  Fiji: {
    id: "FJ",
    name: "Fiji",
  },
  "Falkland Islands (Malvinas)": {
    id: "FK",
    name: "Falkland Islands (Malvinas)",
  },
  "Micronesia, Federated States of": {
    id: "FM",
    name: "Micronesia, Federated States of",
  },
  "Faroe Islands": {
    id: "FO",
    name: "Faroe Islands",
  },
  France: {
    id: "FR",
    name: "France",
  },
  Gabon: {
    id: "GA",
    name: "Gabon",
  },
  "United Kingdom of Great Britain and Northern Ireland": {
    id: "GB",
    name: "United Kingdom of Great Britain and Northern Ireland",
  },
  Grenada: {
    id: "GD",
    name: "Grenada",
  },
  Georgia: {
    id: "GE",
    name: "Georgia",
  },
  "French Guiana": {
    id: "GF",
    name: "French Guiana",
  },
  Guernsey: {
    id: "GG",
    name: "Guernsey",
  },
  Ghana: {
    id: "GH",
    name: "Ghana",
  },
  Gibraltar: {
    id: "GI",
    name: "Gibraltar",
  },
  Greenland: {
    id: "GL",
    name: "Greenland",
  },
  Gambia: {
    id: "GM",
    name: "Gambia",
  },
  Guinea: {
    id: "GN",
    name: "Guinea",
  },
  Guadeloupe: {
    id: "GP",
    name: "Guadeloupe",
  },
  "Equatorial Guinea": {
    id: "GQ",
    name: "Equatorial Guinea",
  },
  Greece: {
    id: "GR",
    name: "Greece",
  },
  "South Georgia and the South Sandwich Islands": {
    id: "GS",
    name: "South Georgia and the South Sandwich Islands",
  },
  Guatemala: {
    id: "GT",
    name: "Guatemala",
  },
  Guam: {
    id: "GU",
    name: "Guam",
  },
  "Guinea-Bissau": {
    id: "GW",
    name: "Guinea-Bissau",
  },
  Guyana: {
    id: "GY",
    name: "Guyana",
  },
  "Hong Kong": {
    id: "HK",
    name: "Hong Kong",
  },
  "Heard Island and McDonald Islands": {
    id: "HM",
    name: "Heard Island and McDonald Islands",
  },
  Honduras: {
    id: "HN",
    name: "Honduras",
  },
  Croatia: {
    id: "HR",
    name: "Croatia",
  },
  Haiti: {
    id: "HT",
    name: "Haiti",
  },
  Hungary: {
    id: "HU",
    name: "Hungary",
  },
  Indonesia: {
    id: "ID",
    name: "Indonesia",
  },
  Ireland: {
    id: "IE",
    name: "Ireland",
  },
  Israel: {
    id: "IL",
    name: "Israel",
  },
  "Isle of Man": {
    id: "IM",
    name: "Isle of Man",
  },
  India: {
    id: "IN",
    name: "India",
  },
  "British Indian Ocean Territory": {
    id: "IO",
    name: "British Indian Ocean Territory",
  },
  Iraq: {
    id: "IQ",
    name: "Iraq",
  },
  "Iran, Islamic Republic of": {
    id: "IR",
    name: "Iran, Islamic Republic of",
  },
  Iceland: {
    id: "IS",
    name: "Iceland",
  },
  Italy: {
    id: "IT",
    name: "Italy",
  },
  Jersey: {
    id: "JE",
    name: "Jersey",
  },
  Jamaica: {
    id: "JM",
    name: "Jamaica",
  },
  Jordan: {
    id: "JO",
    name: "Jordan",
  },
  Japan: {
    id: "JP",
    name: "Japan",
  },
  Kenya: {
    id: "KE",
    name: "Kenya",
  },
  Kyrgyzstan: {
    id: "KG",
    name: "Kyrgyzstan",
  },
  Cambodia: {
    id: "KH",
    name: "Cambodia",
  },
  Kiribati: {
    id: "KI",
    name: "Kiribati",
  },
  Comoros: {
    id: "KM",
    name: "Comoros",
  },
  "Saint Kitts and Nevis": {
    id: "KN",
    name: "Saint Kitts and Nevis",
  },
  "Korea, Democratic People's Republic of": {
    id: "KP",
    name: "Korea, Democratic People's Republic of",
  },
  "Korea, Republic of": {
    id: "KR",
    name: "Korea, Republic of",
  },
  Kuwait: {
    id: "KW",
    name: "Kuwait",
  },
  "Cayman Islands": {
    id: "KY",
    name: "Cayman Islands",
  },
  Kazakhstan: {
    id: "KZ",
    name: "Kazakhstan",
  },
  "Lao People's Democratic Republic": {
    id: "LA",
    name: "Lao People's Democratic Republic",
  },
  Lebanon: {
    id: "LB",
    name: "Lebanon",
  },
  "Saint Lucia": {
    id: "LC",
    name: "Saint Lucia",
  },
  Liechtenstein: {
    id: "LI",
    name: "Liechtenstein",
  },
  "Sri Lanka": {
    id: "LK",
    name: "Sri Lanka",
  },
  Liberia: {
    id: "LR",
    name: "Liberia",
  },
  Lesotho: {
    id: "LS",
    name: "Lesotho",
  },
  Lithuania: {
    id: "LT",
    name: "Lithuania",
  },
  Luxembourg: {
    id: "LU",
    name: "Luxembourg",
  },
  Latvia: {
    id: "LV",
    name: "Latvia",
  },
  Libya: {
    id: "LY",
    name: "Libya",
  },
  Morocco: {
    id: "MA",
    name: "Morocco",
  },
  Monaco: {
    id: "MC",
    name: "Monaco",
  },
  "Moldova, Republic of": {
    id: "MD",
    name: "Moldova, Republic of",
  },
  Montenegro: {
    id: "ME",
    name: "Montenegro",
  },
  "Saint Martin, (French part)": {
    id: "MF",
    name: "Saint Martin, (French part)",
  },
  Madagascar: {
    id: "MG",
    name: "Madagascar",
  },
  "Marshall Islands": {
    id: "MH",
    name: "Marshall Islands",
  },
  "North Macedonia": {
    id: "MK",
    name: "North Macedonia",
  },
  Mali: {
    id: "ML",
    name: "Mali",
  },
  Myanmar: {
    id: "MM",
    name: "Myanmar",
  },
  Mongolia: {
    id: "MN",
    name: "Mongolia",
  },
  Macao: {
    id: "MO",
    name: "Macao",
  },
  "Northern Mariana Islands": {
    id: "MP",
    name: "Northern Mariana Islands",
  },
  Martinique: {
    id: "MQ",
    name: "Martinique",
  },
  Mauritania: {
    id: "MR",
    name: "Mauritania",
  },
  Montserrat: {
    id: "MS",
    name: "Montserrat",
  },
  Malta: {
    id: "MT",
    name: "Malta",
  },
  Mauritius: {
    id: "MU",
    name: "Mauritius",
  },
  Maldives: {
    id: "MV",
    name: "Maldives",
  },
  Malawi: {
    id: "MW",
    name: "Malawi",
  },
  Mexico: {
    id: "MX",
    name: "Mexico",
  },
  Malaysia: {
    id: "MY",
    name: "Malaysia",
  },
  Mozambique: {
    id: "MZ",
    name: "Mozambique",
  },
  Namibia: {
    id: "NA",
    name: "Namibia",
  },
  "New Caledonia": {
    id: "NC",
    name: "New Caledonia",
  },
  Niger: {
    id: "NE",
    name: "Niger",
  },
  "Norfolk Island": {
    id: "NF",
    name: "Norfolk Island",
  },
  Nigeria: {
    id: "NG",
    name: "Nigeria",
  },
  Nicaragua: {
    id: "NI",
    name: "Nicaragua",
  },
  Netherlands: {
    id: "NL",
    name: "Netherlands",
  },
  Norway: {
    id: "NO",
    name: "Norway",
  },
  Nepal: {
    id: "NP",
    name: "Nepal",
  },
  Nauru: {
    id: "NR",
    name: "Nauru",
  },
  Niue: {
    id: "NU",
    name: "Niue",
  },
  "New Zealand": {
    id: "NZ",
    name: "New Zealand",
  },
  Oman: {
    id: "OM",
    name: "Oman",
  },
  Panama: {
    id: "PA",
    name: "Panama",
  },
  Peru: {
    id: "PE",
    name: "Peru",
  },
  "French Polynesia": {
    id: "PF",
    name: "French Polynesia",
  },
  "Papua New Guinea": {
    id: "PG",
    name: "Papua New Guinea",
  },
  Philippines: {
    id: "PH",
    name: "Philippines",
  },
  Pakistan: {
    id: "PK",
    name: "Pakistan",
  },
  Poland: {
    id: "PL",
    name: "Poland",
  },
  "Saint Pierre and Miquelon": {
    id: "PM",
    name: "Saint Pierre and Miquelon",
  },
  Pitcairn: {
    id: "PN",
    name: "Pitcairn",
  },
  "Puerto Rico": {
    id: "PR",
    name: "Puerto Rico",
  },
  "Palestine, State of": {
    id: "PS",
    name: "Palestine, State of",
  },
  Portugal: {
    id: "PT",
    name: "Portugal",
  },
  Palau: {
    id: "PW",
    name: "Palau",
  },
  Paraguay: {
    id: "PY",
    name: "Paraguay",
  },
  Qatar: {
    id: "QA",
    name: "Qatar",
  },
  Réunion: {
    id: "RE",
    name: "Réunion",
  },
  Romania: {
    id: "RO",
    name: "Romania",
  },
  Serbia: {
    id: "RS",
    name: "Serbia",
  },
  "Russian Federation": {
    id: "RU",
    name: "Russian Federation",
  },
  Rwanda: {
    id: "RW",
    name: "Rwanda",
  },
  "Saudi Arabia": {
    id: "SA",
    name: "Saudi Arabia",
  },
  "Solomon Islands": {
    id: "SB",
    name: "Solomon Islands",
  },
  Seychelles: {
    id: "SC",
    name: "Seychelles",
  },
  Sudan: {
    id: "SD",
    name: "Sudan",
  },
  Sweden: {
    id: "SE",
    name: "Sweden",
  },
  Singapore: {
    id: "SG",
    name: "Singapore",
  },
  "Saint Helena, Ascension and Tristan da Cunha": {
    id: "SH",
    name: "Saint Helena, Ascension and Tristan da Cunha",
  },
  Slovenia: {
    id: "SI",
    name: "Slovenia",
  },
  "Svalbard and Jan Mayen": {
    id: "SJ",
    name: "Svalbard and Jan Mayen",
  },
  Slovakia: {
    id: "SK",
    name: "Slovakia",
  },
  "Sierra Leone": {
    id: "SL",
    name: "Sierra Leone",
  },
  "San Marino": {
    id: "SM",
    name: "San Marino",
  },
  Senegal: {
    id: "SN",
    name: "Senegal",
  },
  Somalia: {
    id: "SO",
    name: "Somalia",
  },
  Suriname: {
    id: "SR",
    name: "Suriname",
  },
  "South Sudan": {
    id: "SS",
    name: "South Sudan",
  },
  "Sao Tome and Principe": {
    id: "ST",
    name: "Sao Tome and Principe",
  },
  "El Salvador": {
    id: "SV",
    name: "El Salvador",
  },
  "Sint Maarten, (Dutch part)": {
    id: "SX",
    name: "Sint Maarten, (Dutch part)",
  },
  "Syrian Arab Republic": {
    id: "SY",
    name: "Syrian Arab Republic",
  },
  Eswatini: {
    id: "SZ",
    name: "Eswatini",
  },
  "Turks and Caicos Islands": {
    id: "TC",
    name: "Turks and Caicos Islands",
  },
  Chad: {
    id: "TD",
    name: "Chad",
  },
  "French Southern Territories": {
    id: "TF",
    name: "French Southern Territories",
  },
  Togo: {
    id: "TG",
    name: "Togo",
  },
  Thailand: {
    id: "TH",
    name: "Thailand",
  },
  Tajikistan: {
    id: "TJ",
    name: "Tajikistan",
  },
  Tokelau: {
    id: "TK",
    name: "Tokelau",
  },
  "Timor-Leste": {
    id: "TL",
    name: "Timor-Leste",
  },
  Turkmenistan: {
    id: "TM",
    name: "Turkmenistan",
  },
  Tunisia: {
    id: "TN",
    name: "Tunisia",
  },
  Tonga: {
    id: "TO",
    name: "Tonga",
  },
  Turkey: {
    id: "TR",
    name: "Turkey",
  },
  "Trinidad and Tobago": {
    id: "TT",
    name: "Trinidad and Tobago",
  },
  Tuvalu: {
    id: "TV",
    name: "Tuvalu",
  },
  "Taiwan, Province of China": {
    id: "TW",
    name: "Taiwan, Province of China",
  },
  "Tanzania, United Republic of": {
    id: "TZ",
    name: "Tanzania, United Republic of",
  },
  Ukraine: {
    id: "UA",
    name: "Ukraine",
  },
  Uganda: {
    id: "UG",
    name: "Uganda",
  },
  "United Arab Emirates": {
    id: "AE",
    name: "United Arab Emirates",
  },
  "United States Minor Outlying Islands": {
    id: "UM",
    name: "United States Minor Outlying Islands",
  },
  USA: {
    id: "US",
    name: "USA",
  },
  Uruguay: {
    id: "UY",
    name: "Uruguay",
  },
  Uzbekistan: {
    id: "UZ",
    name: "Uzbekistan",
  },
  "Holy See": {
    id: "VA",
    name: "Holy See",
  },
  "Saint Vincent and the Grenadines": {
    id: "VC",
    name: "Saint Vincent and the Grenadines",
  },
  "Venezuela, Bolivarian Republic of": {
    id: "VE",
    name: "Venezuela, Bolivarian Republic of",
  },
  "Virgin Islands, British": {
    id: "VG",
    name: "Virgin Islands, British",
  },
  "Virgin Islands, U.S.": {
    id: "VI",
    name: "Virgin Islands, U.S.",
  },
  "Viet Nam": {
    id: "VN",
    name: "Viet Nam",
  },
  Vanuatu: {
    id: "VU",
    name: "Vanuatu",
  },
  "Wallis and Futuna": {
    id: "WF",
    name: "Wallis and Futuna",
  },
  Samoa: {
    id: "WS",
    name: "Samoa",
  },
  Yemen: {
    id: "YE",
    name: "Yemen",
  },
  Mayotte: {
    id: "YT",
    name: "Mayotte",
  },
  "South Africa": {
    id: "ZA",
    name: "South Africa",
  },
  Zambia: {
    id: "ZM",
    name: "Zambia",
  },
  Zimbabwe: {
    id: "ZW",
    name: "Zimbabwe",
  },
};

countries.sort((a, b) => {
  const nameA = a.name.toUpperCase();
  const nameB = b.name.toUpperCase();

  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
});

export default countries;
